import { Card, Typography, Tooltip } from "antd";
import { ShopOutlined, ApartmentOutlined, EnvironmentOutlined, UserOutlined } from "@ant-design/icons";
const { Text } = Typography;

export default function BodegasPOCards({ bodegas = [] }) {

  const total = bodegas.length;
  const organizaciones = new Set(bodegas.map((b) => b.oid_organizacion)).size;
  const departamentos = new Set(bodegas.map((b) => b.oid_departamento)).size;
  const responsables = new Set(bodegas.map((b) => b.responsable_login)).size;

  const cards = [
    { title: "Bodegas", value: total, description: "Bodegas registradas", icon: <ShopOutlined />, color: "#1677ff" },
    { title: "Organizaciones", value: organizaciones, description: "Organizaciones con al menos una bodega", icon: <ApartmentOutlined />, color: "#52c41a" },
    { title: "Departamentos", value: departamentos, description: "Departamentos con bodega registrada", icon: <EnvironmentOutlined />, color: "#722ed1" },
    { title: "Responsables", value: responsables, description: "Usuarios responsables distintos", icon: <UserOutlined />, color: "#faad14" }
  ];

  return (
    <div style={{ display: "flex", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
      {cards.map((card, i) => (
        <Card key={i} hoverable style={{ flex: "1 1 200px", borderRadius: 12, padding: 14, boxShadow: "0 4px 10px rgba(0,0,0,0.05)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Text style={{ color: "#6b7280", fontSize: 13, display: "block", marginBottom: 6 }}>{card.title}</Text>
              <Tooltip title={card.description}>
                <div style={{ fontSize: 26, fontWeight: 700, color: "#111827", cursor: "help" }}>{card.value}</div>
              </Tooltip>
            </div>
            <div style={{ background: card.color + "20", color: card.color, width: 48, height: 48, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>
              {card.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
